import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF6E0',
    borderLeftWidth: 3,
    borderLeftColor: '#FFA500',
    paddingVertical: 8,
    paddingHorizontal: 12,
    gap: 8,
  },
  text: {
    flex: 1,
    fontSize: 12,
    lineHeight: 16,
    color: '#A86A00',
    fontFamily: 'TCCC-UnityText',
  },
});
